// extracted by mini-css-extract-plugin
export var measureBox = "_65-0";